<template>
  <div class="home">
    <div class="wrapper-content">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>{{ $t('message.ContactUs') }}</h2>
        </div>
      </div>

      <div class="addmoney">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="contactus panel">
                <ul>
                  <li>
                    <h4>
                      <img class="svg" src="../assets/images/address.svg" alt="address" />
                      <span>{{ $t('message.OfficeAddress') }}</span>
                    </h4>
                    <p>{{address}}</p>
                  </li>
                  <li class="call-address">
                    <h4>
                      <img class="svg" src="../assets/images/telephone.svg" alt="telephone" />
                      <span>{{ $t('message.CallUs') }}</span>
                    </h4>
                    <div class="left-address-call">
                      <!-- <div class="round-image">
                        <img
                          src="../assets/images/round-image.png"
                          alt="image"
                          class="img-responsive"
                        />
                      </div>-->
                      <p>
                        {{name}}
                        <span>+{{phonenumber}}</span>
                      </p>
                    </div>

                    <div class="right-address-call contactUser">
                      <a :href="`tel:+${ phonenumber }`" class="pointer">{{ $t('message.CallNow') }}</a>
                      <a :href="'https://wa.me/'+phonenumber" target="_blank">
                        <img
                          src="https://i.ibb.co/N9P0K9H/239px-Whats-App-svg.png"
                          width="50"
                          height="50"
                        />
                      </a>
                    </div>
                  </li>
                  <li>
                    <h4>
                      <img class="svg" src="../assets/images/email.svg" alt="email" />
                      <span>{{ $t('message.ContactEmail') }}</span>
                    </h4>
                    <p>
                      <a :href="'mailto:'+email">{{email}}</a>
                    </p>
                    <!-- <p></p> -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import { getContactUsDetails } from "./../services/api";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      address: "",
      phonenumber: "",
      email: "",
      name: ""
    };
  },
  created() {
    this.contactUs();
  },

  methods: {
    contactUs() {
      if (!localStorage.getItem("token")) {
        var requestData = {
          user_type: "guest",
          vendor_id: localStorage.getItem("vendorId")
        };
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          vendor_id: localStorage.getItem("vendorId")
        };
      }
      this.isLoading = true;

      getContactUsDetails(requestData)
        .then(result => {
          this.isLoading = false;
          if (result.data.messageCode === 200) {
            this.address = result.data.Contacts[0].address;
            this.phonenumber = result.data.Contacts[0].phoneNo;
            this.email = result.data.Contacts[0].email_id;
            this.name = result.data.Contacts[0].name;
          } else if (result.data.messageCode === 201) {
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    }
  }
};
</script>
